import { render, staticRenderFns } from "./404.vue?vue&type=template&id=25a89e2b&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=25a89e2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a89e2b",
  null
  
)

export default component.exports